<template>
  <div class="col-lg-12 device-data-upload-page page" ref="pageBody" >
      <div class="row file-upload-controls">
        <span>
          Devices:
          <select name="devices" v-model="deviceSelected">
            <option value="" disabled>Select a device to upload data</option>
            <option v-for="(device) in devices" :value="device" :key="device.id+'-'+device.name">{{ device.name }}</option>
          </select>
        </span>
        <!-- old implementation -->
        <!-- <file-upload :fileType="DEVICE_CSV_FILE_TYPE" class="offset-md-5 offset-0 col-md-4 col-sm-12 col-12 "></file-upload> -->
        
        <device-file-upload @device-data-upload="handleFileUpload"></device-file-upload>

      </div>

      <div >
        <!-- TODO: add a form for manual value upload -->
      </div>
      
  </div>
</template>
<script>
import { INIT_NO_OP_NUM } from '@/config'
import FileUpload from '@/components/includes/file/FileUpload';
import DeviceFileUpload from '@/components/includes/file/DeviceFileUpload';
import { 
  mapActions, 
  mapGetters
} from 'vuex';
import { 
  DEVICE_CSV_FILE_TYPE 
} from '@/config';
import { 
  requestVitalSignsCodes
} from '@/api/sessionApi';
import { devices } from '@/data/devices'
import { h } from 'vue';
import { PRIVILEGES } from '@/constants/privileges';
import { assertPrivilegeOrAlert } from '@/utils/privilegeGate';

export default {
  name: 'data-upload-page',
  data () {
    return {
      DEVICE_CSV_FILE_TYPE,
      devices,
      deviceSelected: null
    };
  },
  components: {
    'file-upload': FileUpload,
    'device-file-upload': DeviceFileUpload,
  },
  
  computed: {
    upload() {
      return this.deviceSelected.upload;
    }
  },

  methods: {
    ...mapActions('login',[
      'updateApplicationModel'
    ]),
    ...mapActions('login/watch',[
      'setExternalMeasuresLoaded'
    ]),
    handleFileUpload(file) {
      if (!assertPrivilegeOrAlert(
        PRIVILEGES.UPLOAD_DOCUMENTS,
        'You do not have permission to upload documents.'
      )) {
        return;
      }
      if (this.deviceSelected === null) {
        alert('Please select a device before uploading data');
        return;
      }

      let loader = null;
      if (!file) {

        this.$swal({
          type: 'error',
          title: 'Unable to upload',
          text: 'Please try again or choose another file.',
        })
      } else {
        this.$swal({
          title: `Upload ${file.name}`,
          text: 'This may take a while. Please do not refresh this page while it is uploading.',
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Yes, upload',
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            loader = this.$loading.show({
              container: this.$refs.pageBody
            },{
              after: () => h('div',{},`Uploading...`)
            });

            let formData = new FormData();
            formData.append('file-field', file);

            this.upload(formData)
            .then( () => {
              loader.hide();
              this.setExternalMeasuresLoaded(false);
              this.$swal({
                type: 'success',
                title: 'Device data uploaded',
                text: 'You can go to the Watch/Vitals pages to view data.'
              }).then(() => {
                window.location.reload()
              });

            })
            .catch( (err) => {
              this.$swal({
                type: 'error',
                title: 'Unable to upload',
                text: err,
              });
              console.error(err);
            })
            .finally( () => {
              loader.hide();
              loader = null;
            });
          }
        });

      }
    },
  },
}
</script>

<style lang="scss">

// .file-upload-controls {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }
</style>
